import React from "react";
import { app, pages } from "@microsoft/teams-js";

/**
 * The 'Config' component is used to display your group tabs
 * user configuration options.  Here you will allow the user to
 * make their choices and once they are done you will need to validate
 * their choices and communicate that to Teams to enable the save button.
 */
class TabConfig extends React.Component {
  render() {
    app.initialize().then(() => {
      const getEnvironmentName = () => {
        const host = window.location.hostname.toLowerCase();

        if (host.includes("localhost")) return "(Dev)";
        if (host.includes("qa")) return "(QA)";
        if (host.includes("test")) return "(Test)";
        if (host.includes("demo")) return "(Demo)";
        return "";
      };

      pages.config.registerOnSaveHandler((saveEvent) => {
        const baseUrl = `https://${window.location.hostname}:${window.location.port}`;
        const envName = getEnvironmentName();

        const suggestedDisplayName = `Addovation Share ${envName}`;

        pages.config
          .setConfig({
            suggestedDisplayName,
            entityId: "AddovationShare",
            contentUrl: baseUrl + "/index.html#/tab",
            websiteUrl: baseUrl + "/index.html#/tab",
          })
          .then(() => {
            saveEvent.notifySuccess();
          });
      });

      pages.config.setValidityState(true);
    });

    return (
      <div>
        <h1>Tab Configuration</h1>
        <div>
          This is where you find the Share tab configurations that are available
          when the tab is added to the channel.
        </div>
      </div>
    );
  }
}
export default TabConfig;
